import { createSelector } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { OrderDirection } from '../dto.d'
import { attemptSearchSongs, ListSongsOrderBy } from '../redux/songsSlice'
import { RootState, useAppDispatch } from '../redux/store'

export default function useSongsForTableSelector() {
  const dispatch = useAppDispatch()

  const fetchSongs = (page = 1, pageSize = 10, q: string | undefined = undefined) => {
    const skip = (page - 1) * pageSize
    dispatch(
      attemptSearchSongs({
        skip,
        limit: pageSize,
        q,
        oderBy: ListSongsOrderBy.CREATED_AT,
        oderDirection: OrderDirection.DESC,
      }),
    )
  }

  const selectSongs = (state: RootState) => state.songs

  const songsForTableSelector = createSelector([selectSongs], ({ songs, total }) => {
    const _songs = Object.values(songs).map((song) => {

      return {
        key: song._id,
        picture: song.imageUrl,
        ...song,
      }
    })

    return {
      songs: _songs,
      total,
    }
  })

  const { songs, total } = useSelector(songsForTableSelector)
  return { songs, total, fetchSongs }
}
